/* Setosa one-tap add.
   1. Product cards ([data-setosa-quickadd]): add a single-variant product, then
      open the cart drawer so checkout is one tap away. No drawer on the page?
      Fall back to the cart page.
   2. Cart drawer upsell ([data-setosa-drawer-add]): add and refresh the drawer
      in place.
   Multi-variant products never render these buttons, so no option is guessed. */
(function () {
  var DRAWER_BODY = '#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper';

  function add(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  /* Same endpoint the theme's own drawer uses (theme.js updateSidebarCart). */
  function refreshDrawer() {
    var body = document.querySelector(DRAWER_BODY);
    if (!body) return Promise.reject(new Error('no drawer'));
    return Promise.all([
      fetch('/cart?view=ajax_side_cart', { cache: 'no-store' }).then(function (r) { return r.text(); }),
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      body.innerHTML = res[0];
      /* innerHTML never runs <script> tags. Each cart row carries an inline script that
         defines the stock rules the theme's +/- buttons read, so run them again here,
         otherwise quantity buttons silently stop working after a refresh. */
      Array.prototype.forEach.call(body.querySelectorAll('script'), function (old) {
        var s = document.createElement('script');
        for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
        s.text = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
      document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = res[1].item_count; });
    });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-setosa-quickadd]');
    var up = e.target.closest && e.target.closest('[data-setosa-drawer-add]');
    var btn = card || up;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    add(btn.getAttribute(card ? 'data-setosa-quickadd' : 'data-setosa-drawer-add'))
      .then(function () {
        var drawer = document.getElementById('halo-cart-sidebar');
        if (card && !drawer) { window.location.href = '/cart'; return; }
        /* A refresh hiccup must never lose the added item or bounce the shopper. */
        return refreshDrawer().catch(function () {}).then(function () {
          if (card) { btn.textContent = 'Added ✓'; btn.disabled = false; document.body.classList.add('cart-sidebar-show'); setTimeout(function () { btn.textContent = label; }, 1800); }
        });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        if (card) { window.location.href = btn.closest('a') ? btn.closest('a').href : '/cart'; }
      });
  });

  /* Cart icon (header and mobile header).
     The theme only binds its own cart-icon handler once the whole page has finished
     loading (window.onload). On a phone that can take several seconds, and until then a
     tap is a plain link to the cart page. This handler works from the moment the page
     is parsed: open the drawer at once, then refresh its contents. */
  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('[data-cart-sidebar]');
    if (!icon) return;
    if (document.body.classList.contains('template-cart')) return;
    if (!document.getElementById('halo-cart-sidebar')) return;
    e.preventDefault();
    document.body.classList.add('cart-sidebar-show');
    refreshDrawer().catch(function () {});
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-close-cart-sidebar]')) document.body.classList.remove('cart-sidebar-show');
  }, true);

  /* The discount app injects its own "Buy 1 more of any of these products and get
     7% off" block into the drawer with a black border. We cannot style it by class,
     so find it by its text and tag it (and any wrapper that holds only that text). */
  var NOTE_RE = /(buy|add)\s+\d+\s+more|of any of these products/i;
  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function tagNote() {
    var drawer = document.getElementById('halo-cart-sidebar');
    if (!drawer) return;
    drawer.querySelectorAll('*').forEach(function (el) {
      if (el.classList.contains('setosa-note') || el.closest('.previewCartItem, .scb, .previewCartTotalsPrice, .previewCartAction')) return;
      if (!NOTE_RE.test(el.textContent)) return;
      var deeper = [].some.call(el.children, function (c) { return NOTE_RE.test(c.textContent); });
      if (deeper) return;
      var text = norm(el.textContent), n = el;
      el.classList.add('setosa-note');
      while (n.parentElement && n.parentElement !== drawer && !/(^|\s)(previewCart|halo-sidebar-wrapper|previewCart-wrapper|previewCartInfo)(\s|$)/.test(n.parentElement.className) && norm(n.parentElement.textContent) === text) {
        n = n.parentElement;
        n.classList.add('setosa-note');
      }
    });
  }
  var drawerEl = document.getElementById('halo-cart-sidebar');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () { tagNote(); }).observe(drawerEl, { childList: true, subtree: true, characterData: true });
    tagNote();
  }
})();
